import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Heart, X } from 'lucide-react';
export function WhoIsItFor() {
  return <section className="py-20 px-4 bg-[#F5EBE0]/30" data-id="element-187">
      <div className="max-w-5xl mx-auto" data-id="element-188">
        <FadeIn className="text-center mb-12" data-id="element-189">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900" data-id="element-190">
            Para quién es (y para quién no)
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-191">
          <FadeIn delay={0.1} data-id="element-192">
            <div className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-[#C75B3F] h-full" data-id="element-193">
              <div className="flex items-center mb-6" data-id="element-194">
                <div className="bg-[#C75B3F]/10 p-3 rounded-full mr-4" data-id="element-195">
                  <Heart className="w-6 h-6 text-[#C75B3F]" data-id="element-196" />
                </div>
                <h3 className="text-xl font-bold text-stone-900" data-id="element-197">
                  Es para ti si...
                </h3>
              </div>
              <p className="text-lg text-stone-700" data-id="element-198">
                Quieres una semana más predecible sin volverte rígida. Buscas un
                sistema que entienda que eres humana, que te cansas y que a
                veces las cosas salen mal.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-199">
            <div className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-stone-300 h-full opacity-80" data-id="element-200">
              <div className="flex items-center mb-6" data-id="element-201">
                <div className="bg-stone-100 p-3 rounded-full mr-4" data-id="element-202">
                  <X className="w-6 h-6 text-stone-500" data-id="element-203" />
                </div>
                <h3 className="text-xl font-bold text-stone-900" data-id="element-204">
                  No es para ti si...
                </h3>
              </div>
              <p className="text-lg text-stone-700" data-id="element-205">
                Buscas productividad extrema, optimizar cada segundo de tu día o
                una rutina "perfecta" de Instagram para presumir.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}